import { render, staticRenderFns } from "./RadiologistStudies.vue?vue&type=template&id=4a31d164"
import script from "./RadiologistStudies.vue?vue&type=script&lang=js"
export * from "./RadiologistStudies.vue?vue&type=script&lang=js"
import style0 from "./RadiologistStudies.vue?vue&type=style&index=0&id=4a31d164&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports